import React from 'react'

export default function PreCheckout({}) {
  return <div className="flex flex-col h-full px-6 mt-4">Pre Checkout</div>
}
